import React from 'react'

const Theproblem = () => {
    return (
        <div className="sec problamsection">
            <div className="container">
                <div className="heading_part">
                    <div className="overline">The problem</div>
                    <h2>Dating apps monetise endless searching. We <span> end </span> the search.</h2>
                    <p className="sec-sub">Dating apps were never designed to help you find a partner. They were designed to keep you swiping. FutureSoulmates is the first platform designed to get you out of the app — and into a relationship — as fast as science can deliver.</p>
                </div>
                <div className="grid g3">
                    <div className="card">
                        <div className="cardicon">💔</div>
                        <h3>Years of dating</h3>
                        <p>Average person spends 3–7 years in the dating market. FutureSoulmates reduces that to weeks by searching genetic, physiological, and psychological compatibility first.</p>
                    </div>
                    <div className="card">
                        <div className="cardicon">😮&zwj;💨</div>
                        <h3>Decision fatigue</h3>
                        <p>Infinite choice creates paralysis. FutureSoulmates surfaces your top 5–10 highest-compatibility matches from a database of DNA-verified profiles — not 10,000 strangers.</p>
                    </div>
                    <div className="card">
                        <div className="cardicon">👶</div>
                        <h3>Hidden family-planning risk</h3>
                        <p>1 in 25 people is a carrier for a serious genetic condition. Traditional dating reveals this only after years together — often only at fertility clinic. FutureSoulmates shows it before the first date.</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Theproblem
